import React from 'react';

export default function ErrorMessage({
  title,
  bodyHTML,
  icon = 'error_400',
}: {
  title?: string;
  bodyHTML: string;
  icon?: string;
}): React.ReactElement {
  const message = (
    <div className="alert alert-warning d-flex" role="alert">
      <div className="icon">
        <svg xmlns="http://www.w3.org/2000/svg" className="material-symbols-24">
          <use href={`${materialSymbolsUrl}#${icon}`} />
        </svg>
      </div>
      <div className="message">
        {title && <div className="title">{title}</div>}
        <div
          className="body"
          dangerouslySetInnerHTML={{
            __html: bodyHTML,
          }}
        ></div>
      </div>
    </div>
  );

  return message;
}
